import { ConsoleEvent, CONSOLE_LEVELS } from './console';
import { getCurrentDateTime } from '../lib/dateTime';

type ConsoleHandler = (event: ConsoleEvent) => void;
const handlers: ConsoleHandler[] = [];

/**
 * Adds interceptors to the console to capture logs.
 *
 * @param handlers - The handlers to add to the console interceptor.
 */
export const setupConsoleInterceptor = (handlers: ConsoleHandler[]) => {
  for (const handler of handlers) {
    addHandler(handler);
  }

  for (const level of CONSOLE_LEVELS) {
    // Skip if the level is not a valid console method
    if (!(level in console)) {
      continue;
    }

    const original = console[level] as (...args: unknown[]) => void;
    Object.defineProperty(console, level, {
      value: (...args: unknown[]) => {
        try {
          const event: ConsoleEvent = {
            timestamp: getCurrentDateTime().toISO(),
            level,
            message: args.map(arg => String(arg)).join(' '),
          };

          notifyHandlers(event);
        } catch (err) {
          // Swallow errors so one bad handler doesn't break others
        }

        // Call the original log method
        original.apply(console, args);
      },
      configurable: true,
      writable: true,
    });
  }
};

const addHandler = (handler: ConsoleHandler) => {
  handlers.push(handler);
};

const notifyHandlers = (event: ConsoleEvent): void => {
  for (const handler of handlers) {
    try {
      handler(event);
    } catch (err) {
      // Swallow errors so one bad handler doesn't break others
    }
  }
};
